import { AppError } from "config/errors";
import { fetchDashboardHomeQuery } from "gql/queries/dashboard";
import { getActiveAccount } from "utils/account";

import { createAsyncThunk } from "@reduxjs/toolkit";

/* ------------       THUNKS      ------------------ */

export const getDashboardData = createAsyncThunk(
  "dashboard/getDashboardData",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await fetchDashboardHomeQuery();

      const activeAccount = getActiveAccount(data.me);

      return activeAccount;
    } catch (err) {
      return rejectWithValue(AppError.from(err).toPlainObject());
    }
  }
);
